export default process.env.REACT_APP_MICROSITE_URL;